module.exports = __webpack_public_path__ + "static/media/logo_modified.733c110c.svg";